@if (show) {
  <div class="modal-overlay-shell fixed inset-0 z-[99999] flex items-start justify-center overflow-y-auto p-0 sm:px-5 sm:py-5">
    <div class="fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[32px]" (click)="closeModal()"></div>
    <div
      class="relative flex w-full flex-col rounded-b-3xl bg-white p-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] dark:bg-gray-900 sm:max-h-[calc(100dvh-2.5rem)] sm:max-w-[600px] sm:rounded-3xl sm:p-6 sm:pb-8 lg:p-10 lg:pb-10"
      [ngClass]="{
        'sm:max-w-[600px]': size === 'default',
        'sm:max-w-5xl': size === 'wide',
        'sm:min-h-[720px]': tall,
        'overflow-hidden': !allowOverflow,
        'overflow-visible': allowOverflow
      }"
    >
      <!-- Close Button -->
      <button (click)="closeModal()"
              class="absolute right-3 top-3 z-[999] flex h-9.5 w-9.5 items-center justify-center rounded-full bg-gray-100 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white sm:right-6 sm:top-6 sm:h-11 sm:w-11">
        <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.04289 16.5413C5.65237 16.9318 5.65237 17.565 6.04289 17.9555C6.43342 18.346 7.06658 18.346 7.45711 17.9555L11.9987 13.4139L16.5408 17.956C16.9313 18.3466 17.5645 18.3466 17.955 17.956C18.3455 17.5655 18.3455 16.9323 17.955 16.5418L13.4129 11.9997L17.955 7.4576C18.3455 7.06707 18.3455 6.43391 17.955 6.04338C17.5645 5.65286 16.9313 5.65286 16.5408 6.04338L11.9987 10.5855L7.45711 6.0439C7.06658 5.65338 6.43342 5.65338 6.04289 6.0439C5.65237 6.43442 5.65237 7.06759 6.04289 7.45811L10.5845 11.9997L6.04289 16.5413Z"
                fill=""></path>
        </svg>
      </button>

      <div
        class="modal-scroll-shell flex min-h-0 flex-col pt-12 sm:pt-6 lg:pt-8"
        [ngClass]="{
          'min-h-0 flex-1': !compact
        }"
      >
        <h4 class="mb-6 pr-12 text-3xl font-semibold text-gray-800 dark:text-white/90 sm:mb-7 sm:text-title-sm">
          {{ title }}
        </h4>
        <div
          class="text-sm leading-6 text-gray-500 dark:text-gray-400"
          [ngClass]="{
            'pr-1 sm:min-h-0 sm:flex-1 sm:overflow-y-auto sm:pr-2': !compact && !allowOverflow,
            'pr-1 sm:pr-2': !compact && allowOverflow
          }"
        >
          <ng-content></ng-content>
          @if (content) {
            <p>{{ content }}</p>
          }
        </div>

        @if (showFooter) {
          <div class="mt-6 flex w-full shrink-0 flex-col gap-3 border-t border-gray-100 pb-2 pt-4 dark:border-gray-800 sm:mt-8 sm:flex-row sm:items-end sm:justify-between sm:border-t-0 sm:pb-4 sm:pt-0">
            <div class="flex items-end gap-3">
              <ng-content select="[modal-footer-left]"></ng-content>
            </div>
            <div class="flex w-full flex-col-reverse gap-3 sm:w-auto sm:flex-row sm:items-end sm:justify-end">
              @if (showCloseAction) {
                <button (click)="closeModal()" type="button"
                        [disabled]="processing"
                        [ngClass]="{
                          'flex h-12 w-full items-center justify-center rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium shadow transition-all duration-200 ease-out sm:w-auto': true,
                          'text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200': !processing,
                          'opacity-50 cursor-not-allowed text-gray-400 dark:text-gray-500': processing
                        }">
                  {{ closeButtonLabel }}
                </button>
              }
              @if (confirm) {
                <button (click)="confirmAction()" type="button"
                        [disabled]="processing || confirmDisabled"
                        [ngClass]="{
                          'flex h-12 w-full items-center justify-center rounded-lg px-4 text-sm font-medium text-white shadow transition-all duration-200 ease-out sm:w-auto': true,
                          'bg-brand-500 hover:bg-brand-600': confirmButtonStyle === 'primary' && !processing && !confirmDisabled,
                          'bg-red-500 hover:bg-red-600': confirmButtonStyle === 'danger' && !processing && !confirmDisabled,
                          'bg-green-500 hover:bg-green-600': confirmButtonStyle === 'success' && !processing && !confirmDisabled,
                          'bg-gray-700 hover:bg-gray-800': confirmButtonStyle === 'secondary' && !processing && !confirmDisabled,
                          'opacity-50 cursor-not-allowed bg-brand-400': processing || confirmDisabled
                        }">
                  {{ confirmButtonLabel }}
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
